import { NavLink } from "react-router-dom";

import { PRIMARY_NAV } from "../../../common/navigation";
import styles from "./BottomNav.module.css";

/**
 * Mobile tab bar (PRD §10).
 *
 * The primary device is a phone held in one hand while watching a TV, so
 * the destinations sit within thumb reach and every target is at least
 * 44px tall.
 *
 * `links` exists so a browsing visitor gets a bar with only the tabs they
 * can actually open. Passing the full set would put Home and Profile in
 * front of someone who would be bounced straight back to /welcome.
 */
const BottomNav = ({ links = PRIMARY_NAV, onLinkIntent }) => (
  <nav className={`${styles.BottomNav} d-lg-none`} aria-label="Primary">
    <ul className={styles.list}>
      {links.map((item) => (
        <li key={item.to} className={styles.item}>
          <NavLink
            to={item.to}
            className={({ isActive }) =>
              `${styles.link} ${isActive ? styles.active : ""}`.trim()
            }
            onFocus={() => onLinkIntent?.(item.to)}
            onMouseEnter={() => onLinkIntent?.(item.to)}
          >
            {({ isActive }) => (
              <>
                <i
                  className={isActive ? item.activeIcon : item.icon}
                  aria-hidden="true"
                />
                <span className={styles.label}>{item.label}</span>
              </>
            )}
          </NavLink>
        </li>
      ))}
    </ul>
  </nav>
);

export default BottomNav;
